// Analytics: Experiments feature

export enum ExperimentName {
  Normal = 'normal',
  Free2Paid = 'free2paid',
  ModelComparison = 'model_comparison',
  TranscriptionComparison = 'transcription_comparison',
  Untyped = 'untyped',
}

export type ExperimentProps = {
  experiment_name: ExperimentName;
  // In case we haven't defined an experiment name on the FE (BE is untyped)
  untyped_experiment_name?: string;
};
